// COMPONENTS
import { BaseText, BaseContainer } from "../../../../../../components";

// TODO: do we need tracking numbers in supply too? import TrackingNumber from "./TrackingNumber";

// TYPES
import { BundleItemComponentProps } from "../../types";

// UTILS
import renderBadge from "../../helpers/renderBadge";
import { rightAngleSvg } from "../../../../../../assets";

const BundleItem: React.FC<BundleItemComponentProps> = ({
	item,
	containerClasses,
	leaseBadgeText,
	currencySymbol,
	quantityText,
	addOnBadgeText,
	requiredBadgeText,
	partNumberPrefix,
	trackingNumberPrefix,
	quantityValue,
	partNumberValue,
	titleValue,
	bundleItemGroupSlug,
	isRequired,
	price,
	isLeaseItem,
	imageSrc,
	isNestedBundleItem,
}) => {
	///// CLASS NAMES /////
	const bundleItemContainerClasses = `rounded-lg w-full border-transparent pb-2.5 ${containerClasses}`;
	const bundleItemImageContainerClasses = `mr-5 rounded-lg flex items-center justify-center h-full w-16 max-sm:w-10`;

	///// CONDITIONAL VARS /////
	const showLeaseBadge = bundleItemGroupSlug === "primary" && isLeaseItem;
	return (
		<div className="flex">
			{!isNestedBundleItem && (
				<div className="flex justify-center items-start w-[64px] pl-5 mr-4 max-sm:pl-2 max-sm:mr-2">
					<img src={rightAngleSvg} alt="" className="size-12" />
				</div>
			)}
			<BaseContainer
				key={item?.item?.uuid}
				columnContainerClasses={bundleItemContainerClasses}
				columnShape="semi-rounded"
			>
				<div className="flex items-start w-full">
					<div className={bundleItemImageContainerClasses}>
						<img src={imageSrc} alt="" />
					</div>
					<div className="flex flex-col text-left">
						<div className="flex gap-2">
							{isRequired && (
								<div className="flex flex-row gap-2">
									{renderBadge(requiredBadgeText)}
								</div>
							)}
							{!isRequired && (
								<div className="flex flex-row gap-2">
									{renderBadge(addOnBadgeText)}
								</div>
							)}
							{showLeaseBadge && (
								<div className="flex flex-row gap-2">
									{renderBadge(leaseBadgeText)}
								</div>
							)}
						</div>
						<BaseText
							text={titleValue}
							size="sm:text-lg text-sm"
							color="text-navy-500"
							fontFamily="font-inter-semibold"
							tag="h3"
							additionalClasses="line-clamp-1"
						/>
						<div className="flex gap-x-5">
							<BaseText
								text={`${partNumberPrefix} ${partNumberValue}`}
								size="sm:text-base text-sm"
								color="text-primary-text"
								tag="p"
								fontFamily="font-inter-regular"
							/>
							{/* TODO: do we need tracking numbers in supply too? {item.trackingNumber && (
							<TrackingNumber
								item={item}
								trackingNumberLabel={trackingNumberPrefix}
							/>
						)} */}
						</div>
						<div className="flex flex-row gap-3">
							<BaseText
								text={`${currencySymbol}${price}`}
								size="sm:text-base text-sm"
								color="text-navy-500"
								tag="p"
								fontFamily="font-inter-regular"
							/>
							<BaseText
								text={`${quantityText} ${quantityValue}`}
								size="sm:text-base text-sm"
								color="text-navy-500"
								tag="p"
								fontFamily="font-inter-regular"
							/>
						</div>
					</div>
				</div>
			</BaseContainer>
		</div>
	);
};

export default BundleItem;
